import { ResultOf, TypedDocumentNode, VariablesOf } from '@graphql-typed-document-node/core';
import { SettingsGroup } from 'common/settingsService/impl/models/SettingsGroup';
import { SettingsServiceTypes as Types } from 'common/settingsService/types';
import { FeaturesNames } from 'src/definitions/custom-models';
import { LaunchDarklyFeatureFlags } from 'integrations/launchDarkly/legacy/LaunchDarklyFeatureFlags.types';

type FeatureFlag =
  | {
      source: 'TenantConfig';
      name: FeaturesNames;
    }
  | {
      source: 'LaunchDarkly';
      name: keyof LaunchDarklyFeatureFlags;
    };

interface SourceDocument<
  DOC_NODE extends TypedDocumentNode = TypedDocumentNode,
  ITEMS_MODEL extends Types.GroupItemsModel = Types.GroupItemsModel
> {
  query: DOC_NODE;
  variables: VariablesOf<DOC_NODE> | undefined;
  featureFlags?: FeatureFlag[];
  mapper: (result: { data: ResultOf<DOC_NODE> }) => ITEMS_MODEL;
}

export class SettingsGroupSource<
  DOC_NODE extends TypedDocumentNode = TypedDocumentNode,
  GROUP extends SettingsGroup = SettingsGroup
> {
  private readonly sourceDocument: SourceDocument<DOC_NODE, NonNullable<GROUP['model']['items']>>;

  private readonly defaultState: GROUP;

  constructor(defaultState: GROUP, sourceDocument: SourceDocument<DOC_NODE, NonNullable<GROUP['model']['items']>>) {
    this.sourceDocument = sourceDocument;
    this.defaultState = defaultState;
  }

  get document() {
    return this.sourceDocument;
  }

  get model() {
    return this.defaultState.model;
  }

  get state() {
    return this.defaultState;
  }
}
